import JsBarcode from 'jsbarcode';
import React from 'react';
import { translate } from '../../i18n';
import logo from '../../images/a-logo.svg';

interface ACardProps {
  number?: number;
}

const ACard: React.FC<ACardProps> = ({ number }) => {
  React.useEffect(() => {
    if (!number) return;

    JsBarcode(`#barcode`, number.toString(), {
      width: 1.2,
      height: 40,
      fontSize: 12,
    });
  }, [number]);

  return (
    <div className="ckp-a-acard__wrapper">
      <div className="ckp-a-acard" aria-hidden>
        <div className="ckp-a-acard__inner">
          <div className="ckp-a-card__image">
            <img src={logo} />
            <span>kaart</span>
          </div>
          {number && <svg id="barcode" className="ckp-a-acard__barcode"></svg>}
        </div>
      </div>

      {number && (
        <span className="u-screen-reader-only">{translate('acard.card.sr', { number })}</span>
      )}
    </div>
  );
};

export default ACard;
